<div class="single-select-typeahead" [attr.id]="noLabel && id ? null : domID">
  <ds-typeahead
    [ngModel]="selectedValue"
    [ngModelOptions]="{ standalone: true }"
    [label]="noLabel ? '' : (label | translate)"
    [placeholder]="placeholder ? (placeholder | translate) : ''"
    [required]="required"
    [minSearchLength]="minLengthForSearch"
    [fetchOptions]="dsFetchOptions"
    [displayFn]="dsDisplayFromValue"
    [displayFromValue]="dsDisplayFromValue"
    [compareWith]="dsCompareWith"
    [fetchOnFocus]="fetchOnFocus"
    [openOnFocus]="openOnFocus"
    (optionSelected)="onOptionSelected($event)"
    (cleared)="onCleared()"
    (searchTermChanged)="onSearchTermChanged($event)"
  ></ds-typeahead>
  @if (form && formControlName) {
    <div aria-live="polite" role="status" [id]="formControlName + '_error'" class="error-container">
      <app-form-field-error
        [formValidationRequest$]="formValidationRequest$"
        [field]="form.get(formControlName)"
        [name]="formControlName"
        [label]="label"
      ></app-form-field-error>
    </div>
  }
</div>
